import { render, staticRenderFns } from "./GridComponent.vue?vue&type=template&id=15f44820&scoped=true"
import script from "./GridComponent.vue?vue&type=script&lang=js"
export * from "./GridComponent.vue?vue&type=script&lang=js"
import style0 from "./GridComponent.vue?vue&type=style&index=0&id=15f44820&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f44820",
  null
  
)

export default component.exports